export const getTimeZoneList = () => {
  // @ts-expect-error TS2339: Property 'supportedValuesOf' does not exist on type 'typeof Intl'.
  if (Intl.supportedValuesOf) return Intl.supportedValuesOf('timeZone');

  throw new Error("Property 'supportedValuesOf' does not exist on type 'typeof Intl'");
};

export const getTimeZones = () => {
  const timezones = getTimeZoneList();

  return timezones.map((val: string) => ({
    label: `${val}`,
    value: val,
  }));
};
